<template>
  <div class="flowCenter">
    <div class="box">
      <div class="container clear">
        <div class="main-left fl">
            <sidebar-page></sidebar-page>

        </div>
        <div class="main-right fl">
          <div class="ovhi">
            <div class="fl mr20 mb20">
              <span class="title">任务类型</span>
              <div class="selectBox">
                <el-select v-model="setInfo.platformType" placeholder="请选择" @change="getFlow(setInfo.platformType)">
                  <el-option label="全部" value=""></el-option>
                      <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,fTypes) in fType" :key="fTypes"></el-option>
                  </el-select>
                  <el-select v-model="setInfo.flowType" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                      <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,flow) in flowTypeA" :key="flow"></el-option>
                  </el-select>
                  <!-- <el-cascader :options="options" v-model="selectedOptions" @change="handleChange(selectedOptions)"></el-cascader> -->
              </div>
            </div>
            <div class="fl mr20 mb20">
              <span class="title">任务状态</span>
              <div class="selectBox">
                  <el-select v-model="setInfo.taskStatus" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                      <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,status) in taskstatusList" :key="status"></el-option>
                  </el-select>
              </div>
            </div>
            <div class="fl mb20">
              <el-button type="primary" @click="detailedList()" :loading="detailedLoading">发布流量明细</el-button>
            </div>
          </div>
          <div class=" mr20 mb20">
            <span class="title">搜索筛选</span>
            <div class="selectBox">
              <el-select v-model="taskSearch"  placeholder="请选择">
                  <el-option label="全部" value="1"></el-option>
                    <!-- <el-option label="任务ID" value="2"></el-option> -->
                    <el-option label="宝贝ID" value="3"></el-option>
                    <el-option label="关键词" value="4"></el-option>
                </el-select>
              <el-input placeholder="请输入" v-model="ipinput"  class="input-with-select" style="width: 150px;" v-show="taskSearch!=1" ></el-input>
            </div>
          </div>
          <div class="fl mr20 mb20">
            <span class="title">时间筛选</span>
            <div class="selectBox">
                <el-select v-model="searchTime" placeholder="请选择">
                  <el-option label="发布时间" value="1"></el-option>
                  <el-option label="执行时间" value="2"></el-option>
                </el-select>
            </div>
          </div>
          <div class="fl mr20 mb20">
            <div class="selectBox">
              <el-date-picker
                  v-model="datatime"
                  type="daterange"
                  :editable="false"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  >
                </el-date-picker>
            </div>
          </div>
          <div class="fl mb20">
            <el-button type="primary" @click="searchList()" :loading="searchLoading">查询</el-button>
          </div>
          <div >
            <div class="busTable">
              <el-table :data="templateList" ref="multipleTable" style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
                <el-table-column fixed type="selection" width="35">
                </el-table-column>
                <el-table-column prop="platform" label="平台/任务类型" width="120" align="center">
                  <template slot-scope="scope">
                    <span style="font-weight: bold" v-text="scope.row.platform"></span>
                    <span>/</span>
                    <span style="font-weight: bold" v-text="scope.row.module"></span>
                  </template>
                </el-table-column>
                <el-table-column prop="taskId" label="任务ID" align="center"></el-table-column>
                <!-- <el-table-column prop="module" label="任务类型"  width="100"></el-table-column> -->
                <el-table-column prop="keyword" label="关键词" width="100" align="center"></el-table-column>
                <!-- <el-table-column prop="goodId" label="宝贝ID"  width="120"></el-table-column> -->
                <!-- <el-table-column prop="id" label="任务ID"  width="80"></el-table-column> -->
                <el-table-column prop="exeStatus" label="任务状态" width="100" align="center"></el-table-column>
                <el-table-column prop="quantity" label="天数" width="50" align="center">
                  <template slot-scope="scope">
                    <span v-text="scope.row.days"></span>
                  </template>
                </el-table-column>
                <el-table-column prop="quantity" label="访客数/完成" width="120" align="center">
                  <template slot-scope="scope">
                    <span v-text="scope.row.quantity"></span>/<span v-text="scope.row.complete"></span>
                  </template>
                </el-table-column>

                <el-table-column prop="showNum" label="展现量/完成"  width="100" align="center">
                  <template slot-scope="scope">
                    <span v-text="scope.row.showNum"></span>/<span v-text="(scope.row.complete / scope.row.quantity * scope.row.showNum).toFixed(0)"></span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="fday2" label="发布量/完成量"  width="120">
                  <template slot-scope="scope">
                    <div style="display: inline-block;"><span v-text="(scope.row.quantity + scope.row.showNum) * scope.row.days"></span>/<span v-text="(scope.row.complete / scope.row.quantity * (scope.row.quantity + scope.row.showNum) * scope.row.days).toFixed(0)"></span></div>
                  </template>
                </el-table-column> -->

                <el-table-column prop="createTime" label="发布时间" width="90" align="center"></el-table-column>

                <!-- <el-table-column prop="createTime" label="执行时间"  width="150"></el-table-column> -->
                <el-table-column fixed="right" label="操作" width="150" align="center">
                  <template slot-scope="scope">
                    <span class="imporspan cur-po mr10" @click="lookFlow(scope.row.id, scope.row.platform, scope.row.module, scope.row.httpJson)">查看</span>
                    <span class="imporspan cur-po mr10" @click="cancelTask2(scope.row.id)" v-if="scope.row.exeStatus === '未完成' && ((scope.row.platform === '淘宝' && scope.row.module !== '店铺收藏') || (scope.row.platform !== '淘宝'))">取消</span>
                    <span class="imporspan cur-po" @click="setTemplate(scope.row.id)">存为模板</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="Pagination">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="setInfo.pageNum"
                :page-sizes="[10, 50, 100, 150]"
                :page-size="setInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper"

                :total="count">
              </el-pagination>
            </div>
          </div>
        </div>

        <el-dialog title="流量明细"
        width="40%"
        center
        :visible.sync="dialogDetailed">
          <el-table :data="detailedData">
            <el-table-column property="platform" label="平台" width="150"></el-table-column>
            <el-table-column property="name" label="类型" width="200"></el-table-column>
            <el-table-column property="visitNum" label="访客数"></el-table-column>
            <el-table-column property="showNum" label="展现量"></el-table-column>
          </el-table>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogDetailed = false">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import sidebarPage from '../../components/sidebar'

import http from '../../axios'
export default {
  inject: ['reload'],
  components: {
    sidebarPage
  },
  data () {
    return {
      dialogDetailed: false, // 流量明细dialog
      detailedLoading: false, // 明细loading
      searchLoading: false, // 查询loading
      showcancel: true,
      loading: true,
      selectedOptions: [],
      checkSet: false,
      checkList: [],
      taskstatusList: [
        {
          dictLabel: '未完成',
          dictValue: 1
        },
        {
          dictLabel: '已完成',
          dictValue: 2
        },
        {
          dictLabel: '取消中',
          dictValue: 3
        },
        {
          dictLabel: '已取消',
          dictValue: 4
        }

      ], // 任务状态
      ipinput: '', // 输入的任务id登
      datatime: '',
      taskSearch: '1',
      searchTime: '1', // 时间类型
      tableData: [],
      fTypeOn: 'all',
      fType: [
        {
          dictLabel: '淘宝',
          dictSort: 1,
          dictValue: 'taobao',
          extValue: '01,02,03,05,06,07,08,09,11,12,13,14,15,16'
        },
        {
          dictLabel: '京东',
          dictSort: 2,
          dictValue: 'jingdong',
          extValue: '01,06,08,09,11,13'
        },
        {
          dictLabel: '拼多多',
          dictSort: 3,
          dictValue: 'pinduoduo',
          extValue: '01,06,08,11'
        }
      ],
      flowOn: '0',
      flowTypeA: [],
      flowTypeB: [],
      flowType: [
        {
          dictLabel: 'App流量',
          dictValue: '01'
        },
        {
          dictLabel: '搜索收藏',
          dictValue: '06'
        },
        {
          dictLabel: '搜索加购',
          dictValue: '09'
        },
        {
          dictLabel: '店铺收藏',
          dictValue: '08'
        },
        {
          dictLabel: 'PC流量',
          dictValue: '02'
        },
        {
          dictLabel: '宝贝点赞',
          dictValue: '07'
        },
        {
          dictLabel: '商品收藏',
          dictValue: '11'
        },
        {
          dictLabel: '聚划算',
          dictValue: '12'
        },
        {
          dictLabel: '直接加购',
          dictValue: '13'
        },
        {
          dictLabel: '淘抢购',
          dictValue: '14'
        },
        // {
        //   dictLabel: '达人关注',
        //   dictValue: '15'
        // },
        {
          dictLabel: '直播观看',
          dictValue: '16'
        },
        {
          dictLabel: '逛逛点赞',
          dictValue: '17'
        },
        {
          dictLabel: '抖音关注',
          dictValue: '18'
        },
        {
          dictLabel: '抖音点赞',
          dictValue: '19'
        },
        {
          dictLabel: '抖音播放',
          dictValue: '20'
        }
      ],
      setInfo: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页数量
        orderByColumn: 'createTime', // 排序字段
        isAsc: 'desc', // 倒叙
        platformType: '', // 任务平台
        flowType: '', // 流量平台
        taskStatus: '', // 任务状态
        taskId: '', // 任务id
        goodsId: '', // 商品id
        keyword: '', // 关键词
        startDateBegin: '', // 执行时间
        startDateEnd: '', // 执行时间
        createTimeBegin: '', // 发布时间
        createTimeEnd: '' // 发布时间
      },
      count: 0, // 总条数
      hideType: false, // 未隐藏
      noFinish: '', // 是否隐藏
      multipleSelection: [], // 复选框状态
      setype: false,
      templateList: [],
      detailedData: [] // 流量明细数据
    }
  },
  created () {
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 根据平台类型获取流量类型
    getFlow (value) {
      let _this = this

      if (value !== '') {
        let obj = {}
        obj = _this.fType.find((item) => { // 这里的userList就是上面遍历的数据源
          return item.dictValue === value// 筛选出匹配数据
        })
        let sun1 = obj.extValue.split(',')
        let newobj = {}
        _this.flowTypeA = []
        for (let j = 0; j < sun1.length; j++) {
          _this.flowType.forEach(function (c) {
            if (sun1[j] === c.dictValue) {
              newobj = {}
              newobj.dictLabel = c.dictLabel
              newobj.dictValue = c.dictValue
              _this.flowTypeA.push(newobj)
            }
          })
        }
      } else {
        _this.flowTypeA = _this.flowTypeB
      }
      _this.setInfo.flowType = ''
    },
    // 获取列表
    getDataList () {
      const _this = this
      let params = {
        endTime: '',
        exeStatus: 0,
        hideEnd: 0,
        key: '',
        module: 0,
        page: _this.setInfo.pageNum,
        pageSize: _this.setInfo.pageSize,
        platform: 0,
        searchType: 0,
        startTime: ''
      }
      try {
        http.taskList(params).then(({ data }) => {
          switch (data.code) {
            case 0:
              _this.count = data.page.totalCount
              _this.templateList = data.page.list

              _this.templateList.forEach((item, index) => {
                switch (item.platform) {
                  case 1:
                    item.platform = '淘宝'
                    break
                  case 2:
                    item.platform = '京东'
                    break
                  case 3:
                    item.platform = '拼多多'
                    break
                  case 4:
                    item.platform = '抖音'
                    break
                  default:
                    item.platform = '其他'
                    break
                }
                switch (item.module) {
                  case 1:
                    item.module = 'pc流量'
                    break
                  case 2:
                    item.module = 'APP流量'
                    break
                  case 3:
                    item.module = '猜你喜欢'
                    break
                  case 4:
                    item.module = '淘口令'
                    break
                  case 5:
                    item.module = '搜索收藏'
                    break
                  case 6:
                    item.module = '搜索加购'
                    break
                  case 7:
                    item.module = '店铺收藏'
                    break
                  case 8:
                    item.module = '旺旺打标'
                    break
                  case 9:
                    item.module = '宝贝点赞'
                    break
                  case 10:
                    item.module = '每日好店'
                    break
                  case 11:
                    item.module = '商品收藏'
                    break
                  case 12:
                    item.module = '聚划算'
                    break
                  case 13:
                    item.module = '直接加购'
                    break
                  case 14:
                    item.module = '淘抢购'
                    break
                  case 15:
                    item.module = '达人关注'
                    break
                  case 16:
                    item.module = '直播观看'
                    break
                  case 17:
                    item.module = '逛逛点赞'
                    break
                  case 18:
                    item.module = '抖音关注'
                    break
                  case 19:
                    item.module = '抖音点赞'
                    break
                  case 20:
                    item.module = '抖音播放'
                    break
                  default:
                    item.module = '其他'
                    break
                }
                switch (item.exeStatus) {
                  case 1:
                    item.exeStatus = '未完成'
                    // _this.taskstatusList.dictLabel = '未完成'
                    // _this.$set(_this.taskstatusList[index], 'dictLabel', '未完成')
                    break
                  case 2:
                    item.exeStatus = '已完成'
                    // _this.taskstatusList.dictLabel = '已完成'
                    // _this.$set(_this.taskstatusList[index], 'dictLabel', '已完成')
                    break
                  case 3:
                    item.exeStatus = '取消中'
                    // _this.taskstatusList.dictLabel = '已完成'
                    // _this.$set(_this.taskstatusList[index], 'dictLabel', '已完成')
                    break
                  case 4:
                    item.exeStatus = '已取消'
                    // _this.taskstatusList.dictLabel = '已取消'
                    // _this.$set(_this.taskstatusList[index], 'dictLabel', '已取消')
                    break
                  default:
                    item.exeStatus = '无法完成'
                    // _this.taskstatusList.dictLabel = '取消中'
                    // _this.$set(_this.taskstatusList[index], 'dictLabel', '取消中')
                    break
                }
                // console.log(_this.taskstatusList)
                let str = item.lastQueryTime.substr(0, 10)
                // let speed = Number(item.numberFinish) / Number(item.countPublish) * 100
                // item.speed = speed
                _this.$set(_this.templateList[index], 'lastQueryTime', str)
              })
              _this.loading = false
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    },
    // 流量明细
    detailedList () {
      let _this = this
      _this.detailedLoading = true
      _this.dialogDetailed = false
      let searchType = '0'
      if (_this.taskSearch === '3') {
        searchType = 2
      } else if (_this.taskSearch === '4') {
        searchType = 1
      }
      let platformType = 0
      if (_this.setInfo.platformType === 'taobao') {
        platformType = 1
      } else if (_this.setInfo.platformType === 'jingdong') {
        platformType = 2
      } else if (_this.setInfo.platformType === 'pinduoduo') {
        platformType = 3
      }
      let flowType = 0
      if (platformType === 1) {
        switch (_this.setInfo.flowType) {
          case '01':
            flowType = 2
            break
          case '02':
            flowType = 1
            break
          case '03':
            flowType = 3
            break
          case '05':
            flowType = 4
            break
          case '06':
            flowType = 5
            break
          case '09':
            flowType = 6
            break
          case '08':
            flowType = 7
            break
          case '10':
            flowType = 10
            break
          case '11':
            flowType = 11
            break
          case '12':
            flowType = 12
            break
          case '13':
            flowType = 13
            break
          case '14':
            flowType = 14
            break
          case '15':
            flowType = 15
            break
          case '16':
            flowType = 16
            break
          case '17':
            flowType = 17
            break
          case '18':
            flowType = 18
            break
          case '19':
            flowType = 19
            break
          case '20':
            flowType = 20
            break
          default:
            break
        }
      } else if (platformType === 2) {
        if (_this.setInfo.flowType === '01') {
          flowType = 2
        } else if (_this.setInfo.flowType === '06') {
          flowType = 7
        } else if (_this.setInfo.flowType === '09') {
          flowType = 6
        }
      } else if (platformType === 3) {
        if (_this.setInfo.flowType === '06') {
          flowType = 7
        } else if (_this.setInfo.flowType === '01') {
          flowType = 2
        }
      }
      let time = _this.datatime[0]
      let time1 = _this.datatime[1]
      if (time !== undefined || time1 !== undefined) {
        time = _this.datatime[0] + ' 00:00:00'
        time1 = _this.datatime[1] + ' 23:59:59'
      } else {
        time = ''
        time1 = ''
      }
      let params = {
        endTime: time1,
        exeStatus: _this.setInfo.taskStatus || 0,
        hideEnd: 0,
        key: _this.ipinput,
        module: flowType,
        page: _this.setInfo.pageNum,
        pageSize: _this.setInfo.pageSize,
        platform: platformType,
        searchType: Number(searchType),
        startTime: time,
        timeType: Number(_this.searchTime)
      }
      try {
        http.countList(params).then(({ data }) => {
          _this.detailedLoading = false
          switch (data.code) {
            case 0:
              _this.detailedData = data.data
              _this.dialogDetailed = true
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    },
    // 查询
    searchList () {
      let _this = this
      _this.searchLoading = true
      _this.loading = true
      let searchType = '0'
      if (_this.taskSearch === '3') {
        searchType = 2
      } else if (_this.taskSearch === '4') {
        searchType = 1
      }
      let platformType = 0
      if (_this.setInfo.platformType === 'taobao') {
        platformType = 1
      } else if (_this.setInfo.platformType === 'jingdong') {
        platformType = 2
      } else if (_this.setInfo.platformType === 'pinduoduo') {
        platformType = 3
      }
      let flowType = 0
      if (platformType === 1) {
        switch (_this.setInfo.flowType) {
          case '01':
            flowType = 2
            break
          case '02':
            flowType = 1
            break
          case '03':
            flowType = 3
            break
          case '05':
            flowType = 4
            break
          case '06':
            flowType = 5
            break
          case '09':
            flowType = 6
            break
          case '08':
            flowType = 7
            break
          case '10':
            flowType = 10
            break
          case '11':
            flowType = 11
            break
          case '12':
            flowType = 12
            break
          case '13':
            flowType = 13
            break
          case '14':
            flowType = 14
            break
          case '15':
            flowType = 15
            break
          case '16':
            flowType = 16
            break
          case '17':
            flowType = 17
          case '18':
            flowType = 18
            break
          case '19':
            flowType = 19
            break
          case '20':
            flowType = 20
            break
          default:
            break
        }
      } else if (platformType === 2) {
        if (_this.setInfo.flowType === '01') {
          flowType = 2
        } else if (_this.setInfo.flowType === '06') {
          flowType = 7
        } else if (_this.setInfo.flowType === '09') {
          flowType = 6
        }
      } else if (platformType === 3) {
        if (_this.setInfo.flowType === '06') {
          flowType = 7
        } else if (_this.setInfo.flowType === '01') {
          flowType = 2
        }
      }
      let time = _this.datatime[0]
      let time1 = _this.datatime[1]
      if (time !== undefined || time1 !== undefined) {
        time = _this.datatime[0] + ' 00:00:00'
        time1 = _this.datatime[1] + ' 23:59:59'
      } else {
        time = ''
        time1 = ''
      }
      let params = {
        endTime: time1,
        exeStatus: _this.setInfo.taskStatus || 0,
        hideEnd: 0,
        key: _this.ipinput,
        module: flowType,
        page: _this.setInfo.pageNum,
        pageSize: _this.setInfo.pageSize,
        platform: platformType,
        searchType: Number(searchType),
        startTime: time,
        timeType: Number(_this.searchTime)
      }
      try {
        http.taskList(params).then(({ data }) => {
          _this.searchLoading = false
          _this.loading = false
          switch (data.code) {
            case 0:
              // _this.$message({
              //   type: 'success',
              //   message: '筛选成功!'
              // })
              _this.count = data.page.totalCount
              _this.templateList = data.page.list
              _this.templateList.forEach((item, index) => {
                switch (item.platform) {
                  case 1:
                    item.platform = '淘宝'
                    break
                  case 2:
                    item.platform = '京东'
                    break
                  default:
                    item.platform = '拼多多'
                    break
                }
                switch (item.module) {
                  case 1:
                    item.module = 'pc流量'
                    break
                  case 2:
                    item.module = 'APP流量'
                    break
                  case 3:
                    item.module = '猜你喜欢'
                    break
                  case 4:
                    item.module = '淘口令'
                    break
                  case 5:
                    item.module = '搜索收藏'
                    break
                  case 6:
                    item.module = '搜索加购'
                    break
                  case 7:
                    item.module = '店铺收藏'
                    break
                  case 8:
                    item.module = '旺旺打标'
                    break
                  case 9:
                    item.module = '宝贝点赞'
                    break
                  case 10:
                    item.module = '每日好店'
                    break
                  case 11:
                    item.module = '商品收藏'
                    break
                  case 12:
                    item.module = '聚划算'
                    break
                  case 13:
                    item.module = '直接加购'
                    break
                  case 14:
                    item.module = '淘抢购'
                    break
                  // case 15:
                  //   item.module = '达人关注'
                  //   break
                  case 16:
                    item.module = '直播观看'
                    break
                  case 17:
                    item.module = '逛逛点赞'
                    break
                  case 18:
                    item.module = '抖音关注'
                    break
                  case 19:
                    item.module = '抖音点赞'
                    break
                  case 20:
                    item.module = '抖音播放'
                    break
                  default:
                    item.module = '其他'
                    break
                }
                switch (item.exeStatus) {
                  case 1:
                    item.exeStatus = '未完成'
                    break
                  case 2:
                    item.exeStatus = '已完成'
                    break
                  default:
                    item.exeStatus = '取消中'
                    break
                }
                let str = item.lastQueryTime.substr(0, 10)
                _this.$set(_this.templateList[index], 'lastQueryTime', str)
              })
              _this.loading = false
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    },
    // 取消任务
    cancelTask2 (id) {
      let _this = this
      let arr = []
      if (_this.multipleSelection.length > 0) {
        _this.multipleSelection.forEach(function (c) {
          arr.push(c.id)
        })
      } else {
        arr.push(id)
      }
      let idArray = {
        idArray: arr
      }
      this.$confirm('此操作将取消该任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        try {
          http.cancelTask(idArray).then(({ data }) => {
            switch (data.code) {
              case 0:
                if (data.data.success.length <= 0) {
                  _this.$message({
                    message: '该任务已完成或无法取消',
                    type: 'success'
                  })
                } else {
                  let num = idArray.idArray.length - data.data.success.length
                  if (num > 0) {
                    _this.$message({
                      message: '正在取消,其中' + num + '条取消失败，请检查需要取消的任务的状态',
                      type: 'success',
                      duration: 6000
                    })
                  } else {
                    _this.$message({
                      message: '正在取消中，稍后可查看任务状态',
                      type: 'success',
                      duration: 6000
                    })
                  }
                }
                _this.reload()
                break
              case 401:
                _this.$message.error('账号过期，请重新登录')
                _this.$router.push({path: '/login'})
                break
              default:
                _this.$message.error(data.msg)
                break
            }
          })
        } catch (error) {
          _this.$message.error(error)
        }
      })
    },
    // 查看任务详情,跳转页面
    lookFlow (taskId, platformType, flowType, html) {
      let _this = this
      // let infolist = taskId
      if (platformType === '淘宝') {
        if (flowType === 'pc流量') {
          _this.$router.push({name: 'tbPc', params: {busininfo: html}})
        } else if (flowType === 'APP流量') {
          _this.$router.push({name: 'TbTask', params: {busininfo: html}})
        } else if (flowType === '猜你喜欢') {
          _this.$router.push({name: 'tbLike', params: {busininfo: html}})
        } else if (flowType === '淘口令') {
          _this.$router.push({name: 'tbPassw', params: {busininfo: html}})
        } else if (flowType === '搜索收藏') {
          _this.$router.push({name: 'tbCollection', params: {busininfo: html}})
        } else if (flowType === '搜索加购') {
          _this.$router.push({name: 'tbAdd', params: {busininfo: html}})
        } else if (flowType === '旺旺打标') {
          _this.$router.push({name: 'wangwang', params: {busininfo: html}})
        } else if (flowType === '每日好店') {
          _this.$router.push({name: 'tbDayGood', params: {busininfo: html}})
        } else if (flowType === '商品收藏') {
          _this.$router.push({name: 'tbGoodCollection', params: {busininfo: html}})
        } else if (flowType === '店铺收藏') {
          _this.$router.push({name: 'tbShopCollection', params: {busininfo: html}})
        } else if (flowType === '聚划算') {
          _this.$router.push({name: 'tbJuhuasuan', params: {busininfo: html}})
        } else if (flowType === '直接加购') {
          _this.$router.push({name: 'tbDirectPurchase', params: {busininfo: html}})
        } else if (flowType === '淘抢购') {
          _this.$router.push({name: 'tbRushToBuy', params: {busininfo: html}})
        } else if (flowType === '达人关注') {
          _this.$router.push({name: 'tbDaRen', params: {busininfo: html}})
        } else if (flowType === '直播观看') {
          _this.$router.push({name: 'tbLive', params: {busininfo: html}})
        } else if (flowType === '逛逛点赞') {
          _this.$router.push({name: 'guangguang', params: {busininfo: html}})
        } else if (flowType === '抖音关注') {
          _this.$router.push({name: 'douyinFollow', params: {busininfo: html}})
        } else if (flowType === '抖音点赞') {
          _this.$router.push({name: 'douyinAdd', params: {busininfo: html}})
        } else if (flowType === '抖音播放') {
          _this.$router.push({name: 'douyinPlay', params: {busininfo: html}})
        } else {
          _this.$router.push({name: 'linkes', params: {busininfo: html}})
        }
      } else if (platformType === '京东') {
        if (flowType === 'APP流量') {
          _this.$router.push({name: 'jdAPP', params: {busininfo: html}})
        } else if (flowType === '店铺收藏') {
          _this.$router.push({name: 'jdCollection', params: {busininfo: html}})
        } else if (flowType === '搜索收藏') {
          _this.$router.push({name: 'jdSearchCollection', params: {busininfo: html}})
        } else if (flowType === '直接收藏') {
          _this.$router.push({name: 'jdDirectCollection', params: {busininfo: html}})
        } else if (flowType === '搜索加购') {
          _this.$router.push({name: 'jdAdd', params: {busininfo: html}})
        } else if (flowType === '直接加购') {
          _this.$router.push({name: 'jdDirectAdd', params: {busininfo: html}})
        }
      } else {
        if (flowType === 'APP流量') {
          _this.$router.push({name: 'pddApp', params: {busininfo: html}})
        } else if (flowType === '搜索收藏') {
          _this.$router.push({name: 'pddCollection', params: {busininfo: html}})
        } else if (flowType === '商品收藏') {
          _this.$router.push({name: 'pddGoodCollection', params: {busininfo: html}})
        } else if (flowType === '店铺收藏') {
          _this.$router.push({name: 'pddShopCollection', params: {busininfo: html}})
        }
      }
    },
    // 存为模板
    setTemplate (id) {
      const _this = this
      let arr = []
      arr.push(id)
      let idArray = {
        idArray: arr
      }
      try {
        http.saveTemplate(idArray).then(({ data }) => {
          switch (data.code) {
            case 0:
              _this.$message({
                type: 'success',
                message: '存为模板成功!'
              })
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    },
    // 改变页数时
    handleCurrentChange (currentPage) {
      let _this = this
      _this.setInfo.pageNum = currentPage
      _this.searchList()
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange (size) {
      let _this = this
      _this.setInfo.pageSize = size
      _this.searchList()
    }
  },
  mounted () {
    this.getDataList()
    if (!localStorage.getItem('info')) {
      this.$message({
        type: 'warning',
        message: '请登录后使用'
      })
      this.$router.push({path: '/login'})
    }
  }
}
</script>
<style lang="less" scoped>
.btn_li {
    float: left;
    display: block;
    line-height: 1;
    white-space: nowrap;
    background: #fff;
    border: 1px solid #dcdfe6;
    font-weight: 500;
    border-left: 0;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    cursor: pointer;
    -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
    transition: all .3s cubic-bezier(.645,.045,.355,1);
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 0;
}
.el-table td, .el-table th{
  text-align: center;
}
/deep/ .el-table-column--selection .cell {
  padding-right: 0;
}
.container {
    background:rgba(255,255,255,1);
    border:1px solid rgba(238,238,238,1);
    border-radius:5px;
    width: 1200px;
    margin: auto;
    margin-top: 15px;
    margin-bottom: 15px;
    .main-left {
        width: 15%;
    }
    .main-right {
        width: 85%;
        padding: 15px 30px 27px;
        box-sizing: border-box;
        .title {
          line-height: 36px;
          display: inline-block;
          margin-right: 8px;
        }
        .selectBox {
          display: inline-block;
        }
        /deep/ .el-select{
          width: 130px;
        }
        /deep/ .el-table td{
          font-size: 12px;
        }
        .imporspan {
          color: #FC6B0E;
          cursor: pointer;
          font-weight: bold;
          &:hover{
            opacity: 0.7;
          }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/taskSearch/taskSearch.vue